import React from 'react';

import { L3_PATHS } from 'Deer/constants/routes';
import { useHistory } from 'react-router-dom';
import {
  REVIEW_CYCLE_STEPS_METADATA,
  REVIEW_CYCLE_STEPS_V1,
  useReviewCreationData,
} from 'reducers/reviewCreationSlice';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { ArrowBack } from 'assets/assetsV1/iconComponents';

import { MODULE_KEYS1 } from 'constants/ProjectConstants';
import { routes } from 'constants/routes';

import { SectionHeader } from 'uiToolkitV1/SectionHeader/SectionHeader';

const ReviewCreationHeader = () => {
  let title = '';
  const history = useHistory();

  const { step } = useReviewCreationData();

  switch (step) {
    case REVIEW_CYCLE_STEPS_V1.NAME:
      title = REVIEW_CYCLE_STEPS_METADATA[REVIEW_CYCLE_STEPS_V1.NAME].title;
      break;

    case REVIEW_CYCLE_STEPS_V1.REVIEWEES:
      title = REVIEW_CYCLE_STEPS_METADATA[REVIEW_CYCLE_STEPS_V1.REVIEWEES].title;
      break;

    case REVIEW_CYCLE_STEPS_V1.REVIEWERS:
      title = REVIEW_CYCLE_STEPS_METADATA[REVIEW_CYCLE_STEPS_V1.REVIEWERS].title;
      break;
    case REVIEW_CYCLE_STEPS_V1.ELEMENTS:
      title = REVIEW_CYCLE_STEPS_METADATA[REVIEW_CYCLE_STEPS_V1.ELEMENTS].title;
      break;
    case REVIEW_CYCLE_STEPS_V1.FORM_FILLING_EXPERIENCE:
      title = REVIEW_CYCLE_STEPS_METADATA[REVIEW_CYCLE_STEPS_V1.FORM_FILLING_EXPERIENCE].title;
      break;
    case REVIEW_CYCLE_STEPS_V1.CALIBRATION:
      title = REVIEW_CYCLE_STEPS_METADATA[REVIEW_CYCLE_STEPS_V1.CALIBRATION].title;
      break;
    case REVIEW_CYCLE_STEPS_V1.SHARE_RESULTS:
      title = REVIEW_CYCLE_STEPS_METADATA[REVIEW_CYCLE_STEPS_V1.SHARE_RESULTS].title;
      break;
    case REVIEW_CYCLE_STEPS_V1.TIMELINES:
      title = REVIEW_CYCLE_STEPS_METADATA[REVIEW_CYCLE_STEPS_V1.TIMELINES].title;
      break;
    case REVIEW_CYCLE_STEPS_V1.VALIDATION:
      title = REVIEW_CYCLE_STEPS_METADATA[REVIEW_CYCLE_STEPS_V1.VALIDATION].title;
      break;
    case REVIEW_CYCLE_STEPS_V1.SUMMARY:
      title = REVIEW_CYCLE_STEPS_METADATA[REVIEW_CYCLE_STEPS_V1.SUMMARY].title;
      break;
    default:
      return null;
  }

  const routeToPass = checkNewNavEnabled()
    ? `${L3_PATHS.company.review.settings}?activeTabId=review_cycles`
    : `${routes.moduleSettings}?module=${MODULE_KEYS1.REVIEW}`;

  return (
    <SectionHeader
      title={title}
      leftIconComponent={<ArrowBack boxSize="24px" color="icon.1565BC" />}
      leftIconOnClick={() => {
        history.push(routeToPass);
      }}
      breadCrumbs={[
        {
          label: 'My Reviews',
          route: checkNewNavEnabled() ? L3_PATHS['my-data'].review.myReviews : routes.performanceReview.audit,
        },
        checkNewNavEnabled()
          ? null // Return null to skip this breadcrumb
          : {
              label: 'Preferences',
              route: `${routes.moduleSettings}?module=${MODULE_KEYS1.REVIEW}`,
            },
        {
          label: 'Review Cycles',
          route: checkNewNavEnabled()
            ? `${L3_PATHS.company.review.settings}?activeTabId=review_cycles`
            : `${routes.moduleSettings}?module=${MODULE_KEYS1.REVIEW}`,
        },
        {
          label: 'Create New Review Cycle',
          route: '#',
          isActive: false,
        },
      ].filter(Boolean)}
    />
  );
};

export { ReviewCreationHeader };
